<template>
  <div>
    <headerTop ref="store"></headerTop>
    <storeHeader
      :shopId="shopId"
      :tenantId="goodsdetails.tenantId"
      :shopName="goodsdetails.shopName"
      :logoTop="logoTop"
    ></storeHeader>
    <div class="wrapper">
      <!-- 头部 -->

      <!-- 商品 -->
      <div class="commodity">
        <div class="w11">
          <div style="display: flex; flex: 1">
            <!-- 左边 -->
            <div class="detail_left">
              <!-- <div style="height: 250px; width: 250px; border: 1px solid #e2e2e2">
              <pic-zoom :url="bigImg" v-if="bigImg"></pic-zoom>
              <img
                src="@/assets/images/main/normal_for_test.jpg"
                alt=""
                style="width: 250px; height: 250px; border: 1px solid #ccc"
                v-else
              />
            </div> -->
              <div>
                <img
                  :src="mainImgUrl"
                  style="width: 250px; height: 250px"
                /><!-- v-if="imgUrlList.length !== 0" -->
                <!-- <img
                  src="@/assets/images/shoppingCart/2.png"
                  style="width: 250px; height: 250px; border: 1px solid #ccc"
                  v-if="imgUrlList.length === 0"
                /> -->
              </div>
              <!--展示图片盒子-->
              <div>
                <i
                  style="
                    font-size: 13px;
                    display: inline-block;
                    position: relative;
                    top: 35px;
                    cursor: pointer;
                  "
                  class="iconfont icon-zuojiantou"
                  @click="imgLeft()"
                ></i>
                <ul class="Img_ul">
                  <li
                    v-for="(item, index) in imgUrlList"
                    :key="index"
                    class="Img_li"
                    :style="imgStyle"
                    @click="changeImg(item, index)"
                  >
                    <img
                      :class="index === imgActiveIndex ? 'img_activeBorder' : ''"
                      :src="item"
                      style="width: 50px; height: 50px"
                    />
                    <!-- <img
                              src="@/assets/images/shoppingCart/2.png"
                              style="width:50px;height:50px"
                              v-if="imgUrlList.length === 0"
                            /> -->
                  </li>
                </ul>
                <i
                  style="
                    font-size: 13px;
                    display: inline-block;
                    position: relative;
                    left: 238px;
                    top: -35px;
                    cursor: pointer;
                  "
                  class="iconfont icon-youjiantou"
                  @click="imgRight()"
                ></i>
                <p>
                  <!-- <span class="span4"
                  ><i class="iconfont icon-zuojiantou"></i
                ></span> -->
                  <!-- <span
                  v-for="(item, index) in goodslist"
                  :key="index"
                  @mouseenter="changeImg(item, index)"
                  class="span2"
                >
                  <img :src="item" alt="" v-if="index < 4" />
                </span> -->
                  <!-- <span class="span3" @click="rightcur"
                  ><i class="iconfont icon-youjiantou"></i
                ></span> -->
                </p>
              </div>
            </div>
            <!-- 中间 -->
            <div class="detailcontent">
              <!-- 头部 -->
              <div class="detailcontent_top">
                <div class="cleared">
                  <div class="ziti fl">
                    <!-- <span
                      v-if="goodsdetails.typeName"
                      style="
                        font-size: 12px;
                        margin-top: 3px;
                        max-width: 180px;
                        padding: 2px;
                        background: rgb(71, 196, 96);
                        border-radius: 2px;
                        height: 18px;
                        color: rgb(255, 255, 255);
                        line-height: 12px;
                      "
                      >{{ goodsdetails.typeName }}</span
                    > -->
                    {{ goodsdetails.fullName }}
                  </div>
                  <div class="ziti_right fr">
                    <!-- 收藏 -->

                    <!-- <span @click="go('im')"
                    ><i class="iconfont icon-a-lujing162"></i
                  ></span> -->
                    <xiaopei
                      :oppositeTenantId="goodsdetails.tenantId"
                      :partId="partId"
                    >
                      <i class="iconfont icon-a-lujing162"></i>
                    </xiaopei>
                    <span>
                      <i
                        class="iconfont"
                        :class="
                          goodsdetails.attention
                            ? 'icon-a-ziyuan1'
                            : 'icon-a-lujing157'
                        "
                        @click="collect(goodsdetails)"
                      ></i>
                    </span>
                    <!-- <span v-else
                      ><i
                        class="iconfont"
                        :class="
                          goodsdetails.attention
                            ? 'icon-a-ziyuan1'
                            : 'icon-a-lujing157'
                        "
                        @click="collect(goodsdetails)"
                      ></i
                    ></span> -->
                  </div>
                </div>
              </div>
              <!-- 价格 -->
              <div class="price">
                <p style="position: relative; padding-top: 10px">
                  <span
                    style="
                      margin-right: 71px;
                      margin-left: 20px;
                      color: #9e9e9e;
                      margin-top: 5px;
                    "
                    >价格</span
                  >
                  <span
                    style="
                      color: #e90d0d;
                      font-size: 16px;
                      font-weight: bold;
                      margin-top: 5px;
                    "
                    v-if="goodsdetails.inquiry"
                    >询价</span
                  >
                  <span
                    style=" margin-right: 66px"
                    v-if="!goodsdetails.inquiry"
                    >
                    <span v-if="!goodsdetails.activityType">
                      <span>&yen;</span>
                      <span style="font-size: 24px;">{{ goodsdetails.price }}</span>
                    </span>
                    <span v-else>
                      <span style="text-decoration: line-through;">
                        <span style="font-size: 24px">&yen;</span>
                        <span style="font-size: 24px">{{ goodsdetails.sellPrice }}</span>
                      </span>
                      <span style="font-size: 24px;margin-left: 25px;color: #e90d0d;">&yen;</span>
                      <span style="font-size: 24px; color: #e90d0d;">{{goodsdetails.activityPrice}}</span>
                      <span v-if="goodsdetails.activityType * 1 === 1" style="margin-left: 25px;background-color:#81d3f8;padding:8px;border-radius: 5px;color: #fff;">{{goodsdetails.activityName}}</span>
                      <span v-if="goodsdetails.activityType * 1 === 2" style="margin-left: 25px;background-color:#facd91;padding:8px;border-radius: 5px;color: #fff;">{{goodsdetails.activityName}}</span>
                    </span>
                  </span>
                  <span
                    v-show="goodsdetails.type == 1"
                    style="margin-right: 178px"
                    ><i class="iconfont icon-a-lujing156"></i
                    >{{ goodsdetails.surplusTime }}</span
                  >
                  <!-- 评论 -->
                  <!-- <span
                  style="display:inline-block; width: 58px;height: 32px;position: absolute; right: 172px;"
                >
                  <span
                    style="font-size: 16px;   display: block; color: #9A9A9A;font-weight: bold;width: 38px;height: 16px;"
                    >900+</span
                  >
                  累计评论
                </span> -->
                  <span
                    style="
                      width: 57px;
                      height: 32px;
                      position: absolute;
                      right: 78px;
                    "
                  >
                    <span
                      style="
                        width: 57px;
                        display: block;
                        height: 16px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #9a9a9a;
                      "
                      >{{
                        goodsdetails.monthlySales > 999
                          ? '999+'
                          : goodsdetails.monthlySales
                      }}
                    </span>
                    <span style="display: block; margin-top: 2px"> 月销量</span>
                  </span>
                </p>
                <p style="margin-top: 20px">
                  <span
                    style="margin-right: 69px; margin-left: 20px; color: #9e9e9e"
                    >优惠</span
                  >
                  <!-- <Tooltip theme="light" v-if="ladder.length > 0" max-width="800"> -->
                  <Tooltip theme="light" max-width="800">
                    <div
                      slot="content"
                      class="discounts"
                      v-if="goodsdetails.activityType * 1 === 1"
                    >
                      <p>
                        满{{goodsdetails.giveNum}}{{goodsdetails.unitId}}送{{goodsdetails.giveNum1}}{{goodsdetails.unitId}} &nbsp;
                      </p>
                    </div>
                    <div
                      slot="content"
                      class="discounts"
                      v-else-if="goodsdetails.activityType * 1 === 2"
                    >
                      <p>
                        {{goodsdetails.giveNum}}{{goodsdetails.unitId}}以上,{{goodsdetails.activityPrice}}元/{{ goodsdetails.unitId }} &nbsp;
                      </p>
                    </div>
                    <div
                      slot="content"
                      class="discounts"
                      v-for="(item, index) in ladder"
                      v-else-if="!goodsdetails.activityType && ladder.length > 0"
                      :key="index"
                    >
                      <p>
                        {{ item.orderQuantity }}{{ item.unitId }}以上,{{
                          item.sellPrice
                        }}元/{{ item.unitId }} &nbsp;
                      </p>
                    </div>
                    <span>购买</span>
                    <span
                      class="discounts"
                      v-if="goodsdetails.activityType * 1 === 1"
                    >
                      <!-- {{ item.orderQuantity }}{{ item.unitId }}以上,{{
                        item.sellPrice
                      }}元/{{ item.unitId }} &nbsp; -->
                      满{{goodsdetails.giveNum}}{{goodsdetails.unitId}}送{{goodsdetails.giveNum1}}{{goodsdetails.unitId}} &nbsp;
                    </span>
                    <span
                      class="discounts"
                      v-else-if="goodsdetails.activityType * 1 === 2"
                    >
                      <!-- {{ item.orderQuantity }}{{ item.unitId }}以上,{{
                        item.sellPrice
                      }}元/{{ item.unitId }} &nbsp; -->
                      {{goodsdetails.giveNum}}{{goodsdetails.unitId}}以上,{{goodsdetails.activityPrice}}元/{{ goodsdetails.unitId }} &nbsp;
                    </span>
                    <span
                      class="discounts"
                      v-for="(item, index) in ladder"
                      :key="index"
                      v-else-if="!goodsdetails.activityType && ladder.length > 0"
                    >
                      {{ item.orderQuantity }}{{ item.unitId }}以上,{{
                        item.sellPrice
                      }}元/{{ item.unitId }} &nbsp;
                    </span>
                  </Tooltip>
                  <!-- <span>购买5个以上, <span>170</span>元/个</span>
                <span>10个以上,160元/个</span> -->
                </p>
                <!-- 买赠和单品促销 -->
                <p style="margin-top: 20px" v-if="goodsdetails.activityType">
                  <span style="margin-right: 41px; margin-left: 20px; color: #9e9e9e">
                    活动时间
                  </span>
                  <span style="color: rgb(233, 13, 13)">剩余{{goodsdetails.timeHorizon}}</span>
                  <span style="margin-left: 25px">{{goodsdetails.startTime}}至{{goodsdetails.endTime}}</span>
                </p>
              </div>
              <p class="p2">
                <span
                  style="margin-right: 70px; margin-left: 20px; color: #9e9e9e"
                  >服务</span
                >
                <span v-show="goodsdetails.genuineGuarantee"
                  ><i class="iconfont icon-a-lujing153"></i>正品保证</span
                >
                <span v-show="goodsdetails.technicalSupport"
                  ><i class="iconfont icon-a-ziyuan4"></i>技术支持</span
                >
                <span v-show="goodsdetails.warrantyService"
                  ><i class="iconfont icon-a-ziyuan5"></i>保修服务</span
                >
                <span v-show="goodsdetails.returnPromise"
                  ><i class="iconfont icon-a-ziyuan21"></i>退换货承诺</span
                >
              </p>
              <p style="border-top: 1px dashed #e5e5e5; width: 700px"></p>
              <p class="p3">
                <span
                  class="w123"
                  style="margin-right: 71px; margin-left: 20px; color: #9e9e9e"
                  >库存</span
                >
                <!-- <span class="w114"> -->
                <span class="w112" v-if="warelist.length > 0">
                  {{ wareName }}
                  <i class="ivu-icon ivu-icon-ios-arrow-down"></i>

                  <span class="w113">
                    <span
                      v-for="i in warelist"
                      :key="i.storeId"
                      :class="wareid === i.storeId ? 'cehceked' : ''"
                      @click="changeware(i)"
                    >
                      {{ i.city }} {{ i.name }}
                    </span>
                  </span>
                </span>
                <!-- </span> -->
                <span style="margin-left: 10px;font-size: 18px;color: #f55414"
                  >{{ goodsdetails.stock > 0 ? '有货' : '售空'}}
                </span>
              </p>
              <p class="p4" v-if="!goodsdetails.activityType">
                <span
                  style="margin-right: 56px; margin-left: 20px; color: #9e9e9e"
                  >起订量</span
                >
                <span
                  >{{ goodsdetails.orderQuantity
                  }}{{ goodsdetails.unitId }}及以上</span
                >
              </p>
              <div class="buygoods">
                <span
                  style="margin-right: 45px; margin-left: 20px; color: #9e9e9e"
                  >购买数量</span
                >
                <div class="number-in">
                  <Button
                    style="border-right: 1px solid #dcdee2"
                    class="number-sub"
                    @click="cliSub(goodsdetails)"
                    :disabled="goodsdetails.Sub"
                    >-</Button
                  >
                  <input
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    id="inputValue"
                    @blur="BlurNumber(goodsdetails)"
                    v-model="goodsdetails.maxNum"
                    style="width: 53px; text-align: center; line-height: 31px"
                  />
                  <Button
                    class="number-add"
                    @click="cliAdd(goodsdetails)"
                    :disabled="goodsdetails.Add"
                    >+</Button
                  >
                </div>
                <!-- <InputNumber
                  v-model="goodsdetails.maxNum"
                  controls-outside
                  :min="goodsdetails.minNum"
                  :max="goodsdetails.stockShow"
                  @on-change="buygoods(goodsdetails)"
                  @on-blur="double"
                ></InputNumber> -->
                <div
                  :class="goodsdetails.isNumber ? 'show' : ''"
                  class="number-sp"
                >
                  库存不足
                </div>
                <!-- <span>库存不足</span> -->
                <span class="pricetotalprice" v-if="!goodsdetails.inquiry">{{
                  '¥' + allprice
                }}</span>
              </div>

              <div class="purchase" v-if="!goodsdetails.inquiry">
                <div class="shoppingcar" @click="addcar">
                  <i class="iconfont icon-gouwuche"></i>
                  加入购物车
                </div>
                <div>
                  <button class="btn" v-noresub="1000" @click="promptlybuy">
                    立即购买
                  </button>
                </div>
              </div>
              <div class="purchase" v-else>
                <div>
                  <button
                    style="background-color: #377cf1"
                    class="btn"
                    v-noresub="1000"
                    @click="promptlyxj(goodsdetails)"
                  >
                    立即询价
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边 -->
        <div class="detail_right">
          <h3>
            <i class="iconfont icon-a-zu248"></i>
            {{ goodsdetails.shopName }}
            <!-- <i class="iconfont icon-a-zu248"></i> -->
          </h3>
          <p>
            <i class="iconfont icon-a-lujing147"></i>
            本店热销
          </p>
          <ul>
            <li v-for="(item, index) in hotlist" :key="index">
              <a :href="'/Partsdetails?partId=' + item.id">
                {{
                  (item.stdNameJp == null ? '' : item.stdNameJp) +
                  (item.oeCode == null ? '' : item.oeCode)
                }}
              </a>
              <!-- <a v-else :href="'/Partsdetails?partId=' + item.id">
                {{
                  (item.stdNameJp == null ? '' : item.stdNameJp) +
                  (item.oeCode == null ? '' : item.oeCode)
                }}
              </a> -->
              <!-- </router-link> -->
            </li>
          </ul>
        </div>
      </div>
      <!-- 组合有优惠 -->
      <div class="count" v-if="goodsdetails.activityDetailVos && goodsdetails.activityDetailVos.length > 0">
        <p>组合购买有优惠</p>
        <div style="padding: 10px; border-radius: 8px" class="fl" v-for="(item,ind) in goodsdetails.activityDetailVos" :key="ind" @click="goDetails(item)">
          <!-- 内容 -->
          <div>
            <div class="title">
              <img width="24px" src="@/assets/images/sale.png" alt="" style="vertical-align: bottom">
              {{item.activityName}}
            </div>
            <div style="padding: 10px 0">
              <span class="detail">{{item.totalCount}}个商品</span>
              <span class="detail">组合价</span>
              <span class="detail red" style="font-weight: 700">￥{{item.totalPrice}}</span>
            </div>
            <div>
              <span class="detail">活动剩余</span>
              <span class="red">{{item.timeHorizon}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <ul class="clearfix">
        <li :class="{ on: tabIndex === 0 }" @click="tabIndex = 0">
          <span>商品详情</span>
        </li>
        <!-- <li :class="{ on: tabIndex === 1 }" @click="tabIndex = 1">
          <span>规格参数</span>
        </li> -->
        <li :class="{ on: tabIndex === 2 }" @click="applymotorcycle">
          <span>适用车型</span>
        </li>
<!--        <li :class="{ on: tabIndex === 3 }" @click="tabIndex = 3">-->
<!--          <span>配件描述</span>-->
<!--        </li>-->
        <li :class="{ on: tabIndex === 4 }" @click="tabIndex = 4">
          <span>购买记录</span>
        </li>

      </ul>
      <!-- 商品详情 -->
      <div class="goodsparticulars" v-show="tabIndex === 0">
        <ul class="cleared">
          <li>
            <p>配件编码</p>
            <Tooltip
              :content="goodsdetails.oeCode"
              theme="light"
              max-width="340"
            >
              <span
                style="
                  max-width: 350px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                "
                >{{ goodsdetails.oeCode }}</span
              >
            </Tooltip>
          </li>
          <li>
            <p>配件类型</p>
            <span>{{ goodsdetails.typeName }}</span>
          </li>
          <li>
            <p>品牌</p>
            <span>{{ goodsdetails.brandName }}</span>
          </li>
          <li>
            <p>单位</p>
            <span>{{ goodsdetails.unitId }}</span>
          </li>
          <li>
            <p>标准分组</p>
            <span>{{ goodsdetails.partTypeName }}</span>
          </li>
          <li>
            <p>标准名称</p>
            <span>{{ goodsdetails.stdNameJp }}</span>
          </li>

          <li style="">
            <p>别名</p>
            <Tooltip theme="light" max-width="300">
              <div slot="content">
                <span>{{ partsalias }}</span>
              </div>
              <span class="spanbie">{{ partsalias }}</span>
            </Tooltip>
          </li>
          <li>
            <p>备注</p>
            <span  :title="goodsdetails.remark" style="
                  max-width: 350px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                ">{{ goodsdetails.remark }}</span>
          </li>
          <li>
            <p>规格</p>
            <span>{{ goodsdetails.spec || '--'}}</span>
          </li>
          <li style="width: 100%; display: flex">
            <p >关联原厂件</p>
            <span class="ellipsis">{{ goodsdetails.oemCode }}</span>
          </li>
        </ul>
      </div>
      <!-- 使用车型 -->
      <div class="applycar" v-show="tabIndex === 2">
        <div class="cartype">
          <div style="margin-right: 41px">车厂牌</div>
          <ul>
            <li
              @click="cehsi1(item, index)"
              :class="carchecked1 === index ? 'checked' : ''"
              v-for="(item, index) in brandlist123"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="cartype">
          <span style="margin-right: 41px">主机厂</span>
          <ul>
            <li
              @click="cehsi2(item, index)"
              :class="carchecked2 === index ? 'checked' : ''"
              v-for="(item, index) in mainframelist"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="cartype">
          <span style="margin-right: 33px; width: 50px">车系</span>
          <ul v-if="Demiolist[0]">
            <li
              style="margin-bottom: 10px"
              @click="cehsi3(item, index)"
              :class="carchecked3 === index ? 'checked' : ''"
              v-for="(item, index) in Demiolist"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="cartype1">
          <span style="margin-right: 51px">车型</span>
          <div class="cartable">
            <vxe-table
              border
              show-overflow
              ref="xTable"
              :span-method="rowspanMethod"
              :data="tableData"
              align="center"
              max-height="2500"
            >
              <!-- <vxe-column
              field="factoryName"
              title="主机厂"
              width="124"
            ></vxe-column>
            <vxe-column field="carBrandSeriesName" title="车系" width="131">
            </vxe-column> -->
              <vxe-column field="name" title="车型名称" width="300">
              </vxe-column>
              <vxe-column field="modelYear" title="年款" width="100">
              </vxe-column>
              <vxe-column field="displacement" title="排量" width="120">
              </vxe-column>
              <vxe-column
                field="transmissionDescribe"
                title="变速箱"
                width="180"
              >
              </vxe-column>
              <vxe-column field="gearsNum" title="档位" width="80">
              </vxe-column>
              <vxe-column field="engineNo" title="发动机" width="260">
              </vxe-column>
            </vxe-table>
          </div>
        </div>
        <!-- 表格 -->
      </div>
      <!-- 配件描述 -->
      <div class="applycar" v-show="tabIndex === 3">
        <div v-html="html" v-show="html"></div>
        <div
          v-show="!html"
          style="height: 200px; text-align: center; padding-top: 80px"
        >
          暂无配件描述
        </div>
      </div>
      <div class="applycar" v-show="tabIndex === 4">
        <div class="cartable">
          <vxe-table
              border
              show-overflow
              ref="xTable"
              :span-method="rowspanMethod"
              :data="partsOrderLsit"
              align="center"
              max-height="2500"
          >
            <vxe-column field="createTime" title="日期" width="260">
            </vxe-column>
            <vxe-column field="ordersCode" title="订单编号" width="260">
            </vxe-column>
            <vxe-column field="partNum" title="购买数量" width="260">
            </vxe-column>
            <vxe-column field="state" title="订单状态" width="260">
            </vxe-column>
          </vxe-table>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <footerP></footerP>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Slider></Slider>
  </div>
</template>

<script>
// import PicZoom from 'vue-piczoom'
import headerTop from '@/views/base/common/header-top.vue'
import storeHeader from '@/views/base/common/store-Header.vue'
import Footer from '@/views/base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import {
  gethotsell,
  getshopcar,
  getshopcar1,
  // deleteCount,
  getapplycar,
  getbuygoods,
  getpromptlybuy,
  getpromptlybuy1,
  getgoodsdetails,
  getBasicShopMsg,
  getattention
  // getWare,
  // getStock
} from '../../api/Partsdetails'
import { getGoodsMassage } from '../../api/myweb/goods/goodsManage'
// import registerVue from '../base/login/register.vue'
import Slider from '@/views/base/common/slider.vue'
export default {
  components: {
    // PicZoom,
    Footer,
    footerP,
    headerTop,
    storeHeader,
    xiaopei,
    enquirytk,
    Slider
  },
  data() {
    return {
      show: false,
      // leagueId: this.$route.query.leagueId,
      wareid: '',
      wareName: '',
      warelist: [], // 发货仓数据
      imgUrlList: [], // 商品的图片
      imgActiveIndex: 0, // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0, // 总移动距离
      //大图片默认显示第一张
      mainImgUrl: '',
      // mainImgUrl:require('@/assets/images/main/normal_for_test.jpg'),
      enquirydata: {}, // 询价数据
      html: '', // 富文本渲染
      single: false, // 最小计量单位
      hotlist: [], // 热销数据
      // goodslist: [], // 商品的四张图片
      // bigImg: '', // 第一张图片
      tabIndex: 0, // 切换tabs
      parameterlist: [],
      goodsdetails: {}, //数据
      details: '', // 详情
      id: '', //跳转热销的id
      shopId: '', // 热销的id
      googsDetails: {}, // 传过来的
      carlist: [], // 车辆的品牌
      carchecked: 0, // 车辆颜色的对比
      carchecked1: 0, // 车辆颜色的对比
      carchecked2: 0, // 车辆颜色的对比
      carchecked3: 0, // 车辆颜色的对比
      tableData: [], // 表格
      partId: '', // 进入页面的id
      allprice: '', // 总价
      partsalias: '', // 别名
      logoTop: '', // 顶部图片
      carBrandName: '', // 车厂牌
      factoryName: '', // 主机厂
      carBrandSeriesName: '', // 车系
      ladder: [],
      brandlist123: [], // 车厂牌
      mainframelist: [], // 主机厂
      Demiolist: [], // 车系
      partsSpecVOList: [], // 规格参数
      Packagelenth: '', // 这个是原厂配件号
      copyPrice: '',
      partsOrderLsit: [] //配件的购买记录
    }
  },
  created() {
    this.getgoods()
    // this.getGoodsMassage()

    // this.gethold()
    // this.getgoodsapplycar()
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
      }
    }
  },
  methods: {
    //点击小图片时将图片路径赋值给大图
    changeImg(item, index) {
      this.mainImgUrl = item
      this.imgActiveIndex = index
      if (index < 4) {
        this.imgDistance = 0
      } else {
        this.imgDistance = (index - 3) * -62
      }
      // console.log('距离：'+this.imgDistance, '下标'+this.imgActiveIndex, 'down');
    },
    imgLeft() {
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex-- // 索引值-1
        this.imgUrlList.forEach((item, index) => {
          // 循环小图,通过判断索引值赋值给大图
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item
          }
        })
      }
      if (this.imgActiveIndex >= 3) {
        var index = 0
        const temp = window.setInterval(() => {
          // 利用定时器实现图片左右移动的动画效果
          if (index < 31) {
            // 移动次数(33次)
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 10)
      }
      // console.log('距离：'+this.imgDistance, '下标'+this.imgActiveIndex, 'left');
    },
    imgRight() {
      if (this.imgActiveIndex < this.imgUrlList.length - 1) {
        this.imgActiveIndex++
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item
          }
        })
        if (this.imgActiveIndex >= 4) {
          this.allDistance = -62 * (this.imgActiveIndex - 3)
          var index = 0
          const temp = window.setInterval(() => {
            if (index < 31) {
              this.imgDistance -= 2 // 每次向右移动的距离
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 10)
        }
      } else if (this.imgActiveIndex === this.imgUrlList.length - 1) {
        // 到达最后一张图片，再点击跳转回第一张
        this.imgActiveIndex = 0
        this.mainImgUrl = this.imgUrlList[0]
        var index = 0
        // console.log(this.allDistance,'qq');
        const temp = window.setInterval(() => {
          // 利用定时器实现图片左右移动的动画效果
          if (index < Math.abs(this.allDistance / 2)) {
            // 取绝对值再除
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 1)
      }
      // console.log('距离：'+this.imgDistance, '下标'+this.imgActiveIndex, 'right');
    },

    // 切换图片
    /* changeImg(a, b) {
      this.goodslist.map((item, index) => {
        if (index == b) {
          // item.selected = true
          this.bigImg = a
        }
        // else {
        //   item.selected = false
        // }
      })
    }, */
    // 所有的商品详情
    async getgoods() {
      // this.partId = this.$route.query.googsDetails
      this.partId = this.$route.query.partId
      //console.log(this.partId)
      const res = await getgoodsdetails({
        //    这个接口作用
        partId: this.partId
        // partId: '8221878'
      })
      console.log(res)
      if (res.status) {
        this.warelist = res.data.shipCityStores
        if (res.data.shipCityStore == null) {
          this.wareid = null
          this.wareName = ''
        } else {
          this.wareid = res.data.shipCityStore.storeId
          this.wareName =
            res.data.shipCityStore.city + res.data.shipCityStore.name
        }

        //console.log(res)
        if(res.data.activityType){
          res.data.maxNum =
            res.data.giveNum == null ? 1 : res.data.giveNum
          res.data.minNum =
            res.data.giveNum == null ? 1 : res.data.giveNum
          res.data.Sub = true
        }else{
          res.data.maxNum =
            res.data.orderQuantity == null ? 1 : res.data.orderQuantity
          res.data.minNum =
            res.data.orderQuantity == null ? 1 : res.data.orderQuantity
        }
        this.goodsdetails = res.data
        if (res.data.orderQuantity == null && res.data.stock == 0) {
          this.goodsdetails.stockShow = 999999999999999999999999999999999
        } else {
          // this.goodsdetails.stockShow = this.goodsdetails.stock
        }
        console.log(this.goodsdetails)
        if (res.data.oeCodes) {
          this.Packagelenth = res.data.oeCodes.length
            ? res.data.oeCodes.length
            : ''
        }
        this.ladder = res.data.ladder
        if (this.goodsdetails.alias) {
          this.partsalias = this.goodsdetails.alias.join().split('/')
        }
        let r1, r2, r3, m
        // if()
        r1 = res.data.orderQuantity.toString().split('.')[1]
          ? res.data.orderQuantity.toString().split('.')[1].length
          : 0 // 获取r1小数位的长度
        if (res.data.price !== null) {
          r2 = res.data.price.toString().split('.')[1]
            ? res.data.price.toString().split('.')[1].length
            : 0 // 获取r3小数位的长度
          m = Math.pow(10, Math.max(r1 + r2))
          // 将r1转换为字符串，去除小数点，变为一个整数，乘上m,r2也是，两者再相乘，除去m即可得到结果
          if(res.data.activityType) {
            let r3 = res.data.activityPrice.toString().split('.')[1]
            ? res.data.activityPrice.toString().split('.')[1].length
            : 0 // 获取r3小数位的长度
            let m1 = Math.pow(10, Math.max(r1 + r3))
            this.allprice =
            (Number(res.data.giveNum.toString().replace('.', '')) *
              Number(res.data.activityPrice.toString().replace('.', ''))) /
            m1
          }else{
            console.log('-----------------');
            this.allprice =
            (Number(res.data.orderQuantity.toString().replace('.', '')) *
              Number(res.data.price.toString().replace('.', ''))) /
            m
          }
        }
        this.copyPrice = JSON.parse(JSON.stringify(this.allprice))
        // this.allprice = res.data.orderQuantity * res.data.price
        this.partsSpecVOList = res.data.partsSpecVOList
        if (res.data.pictures) {
          /* this.goodslist = res.data.pictures
          this.bigImg = this.goodslist[0] */
          this.imgUrlList = res.data.pictures
          this.mainImgUrl = this.imgUrlList[0]
          if (this.imgUrlList.length == 0) {
            this.imgUrlList[0] = require('@/assets/images/shoppingCart/2.png')
            this.mainImgUrl = require('@/assets/images/shoppingCart/2.png')
            // console.log(this.mainImgUrl, 'yangjiashi')
          }
        }
        this.shopId = res.data.shopId
        this.html = res.data.content
        // this.getgoodsapplycar()
        // 获取商品右侧热销
        this.gethold()
        // 获取顶部图片
        this.getshopping()
        // if (this.$route.query.leagueId) {
        //   // 获取发货仓
        //   this.getWareList()
        // }

        if (this.goodsdetails.isMinUnit) {
          this.single = true
        } else {
          this.single = false
          // this.single = true
        }
      } else {
        this.$Message.error(res.message)
      }
      this.partsOrderLsit = res.data.partsOrders
      this.getPartStateName()
    },
    getPartStateName(){
      this.partsOrderLsit.forEach(function ( item){
        switch (item.state) {
          case 1:
            item.state = '待付款'
            break
          case 2:
            item.state = '待发货'
            break
          case 3:
            item.state = '待收货'
            break
          case 5:
            item.state = '已完成'
            break
          case 6:
            item.state = '已取消'
            break
          case 8:
            item.state = '已确认运费'
            break
          case 9:
            item.state = '退款申请中'
            break
          case 10:
            item.state = '退货(并退款)申请中'
            break
          case 11:
            item.state = '交易关闭'
            break
          case 14:
            item.state = '仓库处理中'
            break
          default:
            item.state = '--'
        }
      })
    },

    // 获取发货仓数据
    // async getWareList() {
    //   if (this.$route.query.storeId) {
    //     // this.wareid = this.$route.query.storeId
    //     const res = await getStock({
    //       tenantId: this.goodsdetails.tenantId,
    //       partsId: this.$route.query.partId,
    //       storeId: this.wareid
    //     })
    //     console.log(res)
    //     if (res.status) {
    //       this.warelist = res.data.detail
    //       const a = this.warelist.filter((item) => {
    //         return item.id == this.$route.query.storeId
    //       })
    //       console.log(a)
    //       if (this.warelist.length > 0) {
    //         if (a.length == 0) {
    //           console.log('3333')
    //           this.wareid = this.warelist[0].id
    //           this.wareName = this.warelist[0].name
    //           this.goodsdetails.stock = this.warelist[0].value
    //         } else {
    //           console.log('7777')
    //           // this.wareid = this.$route.query.storeId
    //           this.wareName = a[0].name
    //           this.wareid = a[0].id
    //           this.goodsdetails.stock = a[0].value
    //         }
    //       }

    //       // console.log(a);
    //       // this.wareName = this.warelist[0].name
    //       // this.wareid = this.warelist[0].id
    //       // this.goodsdetails.stock = this.warelist[0].value
    //       this.goodsdetails.stockShow = this.goodsdetails.stock
    //     }
    //   } else {
    //     const data = await getStock({
    //       tenantId: this.goodsdetails.tenantId,
    //       partsId: this.$route.query.partId
    //       // storeId: this.wareid
    //     })
    //     console.log(data)
    //     if (data.status) {
    //       this.warelist = data.data.detail
    //       if (this.warelist.length > 0) {
    //         this.wareName = this.warelist[0].name
    //         this.wareid = this.warelist[0].id
    //         this.goodsdetails.stock = this.warelist[0].value
    //         this.goodsdetails.stockShow = this.goodsdetails.stock
    //       }
    //       // const a = this.warelist.filter((item) => {
    //       //   return item.id == this.$route.query.storeId
    //       // })
    //     }
    //   }

    //   // const list = await getWare({ tenantId: this.goodsdetails.tenantId })
    //   // console.log(list)
    //   // if (list.status) {
    //   //   this.warelist = list.data
    //   //   if (this.warelist.length > 0) {
    //   //     if (this.$route.query.storeId) {
    //   //       this.wareid = this.$route.query.storeId
    //   //       const a = this.warelist.filter((item) => {
    //   //         return item.id == this.$route.query.storeId
    //   //       })
    //   //       // console.log(a);
    //   //       this.wareName = a[0].name
    //   //     } else {
    //   //       this.wareName = this.warelist[0].name
    //   //       this.wareid = this.warelist[0].id
    //   //     }
    //   //   }
    //   // }
    //   // console.log(this.wareid)
    //   // // 获取当前库存
    //   // this.getStock()
    // },
    // 获取联盟不同仓库的库存
    // async getStock() {
    //   console.log(this.wareid)
    //   // let data = ''
    //   // if (this.wareid) {
    //   //   data = {
    //   //     tenantId: this.goodsdetails.tenantId,
    //   //     partsId: this.$route.query.partId,
    //   //     storeId: this.wareid
    //   //   }
    //   // } else {
    //   //   data = {
    //   //     tenantId: this.goodsdetails.tenantId,
    //   //     partsId: this.$route.query.partId
    //   //   }
    //   // }
    //   const res = await getStock({
    //     tenantId: this.goodsdetails.tenantId,
    //     partsId: this.$route.query.partId,
    //     storeId: this.wareid
    //   })
    //   if (res.status) {
    //     if (res.data.detail.length == 0) {
    //       this.goodsdetails.stock = res.data.stock
    //       this.goodsdetails.stockShow = this.goodsdetails.stock
    //     } else {
    //       const a = this.warelist.filter((item) => {
    //         return item.id == this.wareid
    //       })
    //       this.wareName = a[0].name
    //       this.goodsdetails.stock = a[0].value
    //       this.goodsdetails.stockShow = this.goodsdetails.stock
    //     }
    //   }
    //   console.log(res)
    // },
    // 跳转订单详情
    goDetails(item) {
      this.$router.push({
        path: '/PartsdetailsGroup',
        query: {
          partId: item.activityId
        }
      })
    },
    partsjump(item) {
      this.$router.push({
        path: '/Partsdetails',
        query: { partId: item.id }
      })
      // this.getgoods()
      // this.getGoodsMassage()
      location.reload()
    },
    // 获取商品描述
    async getGoodsMassage() {
      const res = await getGoodsMassage({ partId: this.$route.query.partId })
      if (res.status) {
        this.html = res.data.content
        console.log(res, '5555')
      }
    },
    // 点击变化
    async buygoods(val) {
      // console.log(this.goodsdetails.maxNum, this.goodsdetails.stock)
      // console.log(val.maxNum, this.goodsdetails.stock)
      // this.goodsdetails.stockShow = 999999999999999999999999999999999
      if (
        this.goodsdetails.stock == 0 &&
        this.goodsdetails.orderQuantity == null
      ) {
        this.goodsdetails.stockShow = this.goodsdetails.stock
      }
      // else {
      console.log('111')
      console.log(val.maxNum, this.goodsdetails.stock)
      // this.$nextTick(async () => {
      if (val.maxNum > this.goodsdetails.stock) {
        // 购买数量超过库存数量
        this.goodsdetails.stockShow = this.goodsdetails.maxNum - 1
        val.isNumber = true
        console.log('222')
      } else {
        if (val.maxNum == null) {
          val.maxNum = null
        } else {
          if (val.maxNum === this.goodsdetails.stock) {
            this.goodsdetails.stockShow = val.maxNum
            console.log('333')
          }
          this.goodsdetails.isNumber = false
          // a.maxNum = Math.floor(a.maxNum)
          // console.log(a.maxNum)
          // this.goodsdetails.maxNum = a.maxNum
        }
      }
      let a = ''
      a = {
        tenantId: this.goodsdetails.tenantId,
        shopId: this.goodsdetails.shopId,
        partId: this.partId,
        partNum:
          this.goodsdetails.maxNum == null
            ? this.goodsdetails.orderQuantity
            : this.goodsdetails.maxNum,
        storeId: this.wareid
      }
      const res = await getbuygoods(a)
      console.log(res, '999')
      if (res.status) {
        this.allprice = res.data.amount
        this.goodsdetails.price = res.data.price
      }
      // })
      // this.$nextTick(() => {
      //   console.log('4444')
      //   if (this.goodsdetails.stock < a.maxNum) {
      //     // 购买数量超过库存数量
      //     console.log(Math.floor(a.maxNum))
      //     this.goodsdetails.stockShow = this.goodsdetails.maxNum - 1
      //     console.log(a.stockShow, a.maxNum)
      //     // this.goodsdetails.maxNum = this.goodsdetails.stock
      //   } else {
      //     if (a.maxNum == null) {
      //       console.log(a.maxNum)
      //       a.maxNum = null
      //     } else {
      //       a.maxNum = Math.floor(a.maxNum)
      //       this.goodsdetails.maxNum = a.maxNum
      //     }
      //   }
      // })
      // }
    },
    double() {
      this.goodsdetails.stockShow = 999999999999999999999999999999999
      // debugger
      console.log('触发了这个方法')
      console.log('double', this.goodsdetails.maxNum)
      if (this.goodsdetails.maxNum == null) {
        console.log('走到了这一步')
        this.goodsdetails.maxNum = this.goodsdetails.orderQuantity
      }

      if (this.goodsdetails.maxNum > this.goodsdetails.stock) {
        console.log('444')
        this.goodsdetails.isNumber = true
        console.log(this.goodsdetails.isNumber)
        // this.goodsdetails.stockShow = this.goodsdetails.maxNum - 1
      } else {
        // this.goodsdetails.stockShow = this.goodsdetails.maxNum - 1
        // if (this.goodsdetails.maxNum == this.goodsdetails.stock) {
        //   this.goodsdetails.stockShow = this.goodsdetails.maxNum
        // }
        this.goodsdetails.isNumber = false
      }
    },
    // 数据失焦时触发
    async BlurNumber(goodsdetails) {
      console.log(goodsdetails)
      if(goodsdetails.activityType && goodsdetails.maxNum < goodsdetails.giveNum){
        this.goodsdetails.maxNum = this.goodsdetails.giveNum
        return this.$Message.warning('购买数量不能小于起购数量！')
      }
      if (
        this.goodsdetails.stock == 0 &&
        this.goodsdetails.orderQuantity == null
      ) {
        this.goodsdetails.maxNum = 1
      }
      let reg = /^[1-9]\d*$/
      if (!reg.test(goodsdetails.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
      } else {
        if (goodsdetails.inquiry == 1) {
        } else {
          if (
            goodsdetails.maxNum > goodsdetails.stock ||
            goodsdetails.maxNum == goodsdetails.stock
          ) {
            this.$set(this.goodsdetails, 'Add', true)
            if (goodsdetails.maxNum > goodsdetails.stock) {
              goodsdetails.isNumber = true
            } else if (goodsdetails.maxNum == goodsdetails.stock) {
              this.$set(this.goodsdetails, 'isNumber', false)
            }

            //       this.$set(this.dataList[index], 'Add', true)
            //       console.log('333333')
            //       // if (item.maxNum > item.stock) {
            //       this.$set(this.dataList[index], 'isNumber', true)
            //       // }
            //       // else if (item.maxNum == item.stock) {
            //       //   this.$set(this.dataList[index], 'isNumber', false)
            //       // }
          } else {
            this.$set(this.goodsdetails, 'Add', false)
            this.$set(this.goodsdetails, 'isNumber', false)
            //       if (item.maxNum == 1) {
            //         this.$set(this.dataList[index], 'Sub', true)
            //       }
          }
          let a = ''
          a = {
            tenantId: this.goodsdetails.tenantId,
            shopId: this.goodsdetails.shopId,
            partId: this.partId,
            partNum:
              this.goodsdetails.maxNum == null
                ? this.goodsdetails.orderQuantity
                : this.goodsdetails.maxNum,
            storeId: this.wareid
          }
          const res = await getbuygoods(a)
          console.log(res, '999')
          if (res.status) {
            this.allprice = res.data.amount
            this.goodsdetails.price = res.data.price
          }
        }
      }
      //   // }
      // }
    },
    // 减法
    cliSub(goodsdetails) {
      if(goodsdetails.activityType){
        if(goodsdetails.maxNum <= goodsdetails.minNum + 1){
          this.$set(this.goodsdetails, 'Sub', true)
        }
      }
      if (goodsdetails.maxNum == 1) {
        // this.$set(this.dataList[index], 'Sub', true)
      } else {
        let oipt = document.getElementById('inputValue')
        console.log(oipt)
        this.$delete(this.goodsdetails, 'maxNum')
        this.$set(this.goodsdetails, 'maxNum', oipt.value * 1 - 1)
        this.BlurNumber(goodsdetails)
        // this.$set(this.dataList[index], 'Sub', false)
      }
    },
    // 加法
    cliAdd(goodsdetails) {
      if(goodsdetails.activityType) this.$set(this.goodsdetails, 'Sub', false)
      let oipt = document.getElementById('inputValue')
      this.$delete(this.goodsdetails, 'maxNum')
      this.$set(this.goodsdetails, 'maxNum', oipt.value * 1 + 1)
      this.BlurNumber(goodsdetails)
    },
    // 热销数据
    // 点击的右边
    // rightcur() {
    //   console.log(123)
    //   console.log(this.goodslist)
    //   for (let index = 0; index < this.goodslist.length; index++) {
    //     const element = this.goodslist[index]
    //     console.log(element)
    //   }
    // Aftermarket
    // },

    // 热销
    async gethold() {
      //console.log(this.shopId)
      // this.googsDetails = this.$route.query.googsDetails
      const res = await gethotsell({
        num: 5,
        shopId: this.shopId,
        tenantId: this.goodsdetails.tenantId
      })
      //console.log(res)
      if (res.status) {
        this.hotlist = res.data.list
      } else {
        this.$Message.error(res.message)
      }
    },
    // 点击适用车型
    applymotorcycle() {
      this.tabIndex = 2
      this.getgoodsapplycar()
    },
    // 适用车型
    async getgoodsapplycar() {
      const res = await getapplycar({
        // partId: '1483831145943138304',
        partId: this.partId,
        carBrandName: this.carBrandName, // 车厂牌
        factoryName: this.factoryName, // 主机厂
        carBrandSeriesName: this.carBrandSeriesName // 车系
      })
      //console.log(res)
      if (res.status) {
        this.brandlist123 = res.data.carBrandName
        this.mainframelist = res.data.factoryName
        this.Demiolist = res.data.carBrandSeriesName ? res.data.carBrandSeriesName : []
        this.tableData = res.data.chirdren
      }
      // this.carlist = res.data.list
      // console.log(this.carlist)
      // if (this.carlist.length > 0) {
      //   this.tableData = this.carlist[0].chirdren.slice(0, 50)
      // }
    },
    // 加入购物车
    addcar() {
      console.log(this.goodsdetails,'-----------');
      if (this.goodsdetails.maxNum < this.goodsdetails.orderQuantity) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能小于起订数量')
        return
      }
      if (
        this.goodsdetails.stock !== 0 &&
        this.goodsdetails.stock >= this.goodsdetails.orderQuantity
      ) {
        const data = []
        let obj = {
          tenantId: this.goodsdetails.tenantId,
          shopId: this.shopId,
          shopName: this.goodsdetails.shopName,
          partId: this.partId,
          partCode: this.goodsdetails.oeCode,
          partNum: this.goodsdetails.maxNum
            ? this.goodsdetails.maxNum
            : this.goodsdetails.orderQuantity,
          partQualityType: this.goodsdetails.qualityTypeId,
          carBrandName: this.goodsdetails.carBrandName,
          partInnerId: this.goodsdetails.partInnerId,
          direction: this.goodsdetails.direction
            ? this.goodsdetails.direction
            : '',
          price: this.goodsdetails.price,
          stdNameJp: this.goodsdetails.stdNameJp
            ? this.goodsdetails.stdNameJp
            : '',
          // leagueId: this.$route.query.leagueId,
          storeId: this.wareid
        }
        data.push(obj)
        // 赠品也加入购物车
        // if(this.goodsdetails.isGiveList&&this.goodsdetails.isGiveList.length && this.goodsdetails.maxNum >= this.goodsdetails.giveNum) {
        //   console.log(this.goodsdetails.maxNum,this.goodsdetails.giveNum);
        //   this.goodsdetails.isGiveList.forEach(async(item) => {
        //     let res = await getgoodsdetails({partId: item.partsId})
        //     let obj2 = {
        //       tenantId: res.data.tenantId,
        //       shopId: res.data.shopId,
        //       shopName: res.data.shopName,
        //       partId: item.partsId,
        //       partCode: res.data.oeCode,
        //       partNum: this.goodsdetails.giveNum1,
        //       partQualityType: res.data.qualityTypeId,
        //       carBrandName: res.data.carBrandName,
        //       partInnerId: res.data.partInnerId,
        //       direction: res.data.direction
        //         ? res.data.direction
        //         : '',
        //       price: res.data.price,
        //       stdNameJp: res.data.stdNameJp
        //         ? res.data.stdNameJp
        //         : '',
        //       storeId: this.wareid
        //     }
        //     data.push(obj2)
        //     this.car(data)
        //   })
        // }else{
        //   this.car(data)
        // }
        this.car(data)
        // const res = await getshopcar(data)
        // //console.log(res)
        // if (res.status) {
        //   this.$Message.destroy()
        //   this.$Message.success('加入购物车成功')
        //   this.$nextTick(() => {
        //     this.goodsdetails.maxNum = this.goodsdetails.orderQuantity
        //     this.allprice =
        //       this.goodsdetails.price * this.goodsdetails.orderQuantity
        //     this.$refs.store.getCount()
        //   })
        // }
      } else {
        this.$Message.destroy()
        this.$Message.error('库存不足')
      }
    },
    async car(val) {
      // console.log(val,'----');
      let res
      // 活动商品计入购物车
      if(this.goodsdetails.activityType){
        res = await getshopcar1(val)
      }else{
        // 非活动商品加入购物车
        res = await getshopcar(val[0])
      }
        //console.log(res)
      if (res.status) {
        this.$Message.destroy()
        this.$Message.success('加入购物车成功')
        this.$nextTick(() => {
          if(this.goodsdetails.activityType) {
            this.goodsdetails.maxNum = this.goodsdetails.giveNum
            this.allprice =
              this.goodsdetails.activityPrice * this.goodsdetails.giveNum
          }else{
            this.allprice =
              this.goodsdetails.price * this.goodsdetails.orderQuantity
              this.goodsdetails.maxNum = this.goodsdetails.orderQuantity
          }
          // this.goodsdetails.maxNum = this.goodsdetails.orderQuantity
          // this.allprice =
          //   this.goodsdetails.price * this.goodsdetails.orderQuantity
          this.$refs.store.getCount()
        })
      }
    },
    // 收藏
    async collect(item) {
      item.attention = !item.attention
      //console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.id,
        attention: item.attention
      })
      //console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
      // 收藏
      // if (this.flag) {
      //   console.log('取消收藏')
      // } else {
      //   console.log('收藏成功')
      // }
    },
    // 车型的合并
    rowspanMethod({ row, _rowIndex, column, visibleData }) {
      let fields = ['name', 'modelYear']
      let cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        let prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (column.property === 'modelYear') {
          if (
            prevRow &&
            prevRow[column.property] === cellValue &&
            prevRow['name'] === row['name']
          ) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (
              nextRow &&
              nextRow[column.property] === cellValue &&
              nextRow['name'] === row['name']
            ) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }

            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        } else {
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
    // 立即购买
    async promptlybuy() {
      console.log('----------------123');
      if (this.goodsdetails.maxNum < this.goodsdetails.orderQuantity) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能小于起订数量')
        return
      }
      if (
        this.goodsdetails.stock !== 0 &&
        this.goodsdetails.stock >= this.goodsdetails.orderQuantity
      ) {
        // let data = ''
        // // if (this.$route.query.leagueId) {
        // data = {
        //   partId: this.partId, // 商品id
        //   tenantId: this.goodsdetails.tenantId, // 店铺的租户id
        //   partNum:
        //     this.goodsdetails.maxNum == null
        //       ? this.goodsdetails.orderQuantity
        //       : this.goodsdetails.maxNum, // 购买数量
        //   shopId: this.shopId, // 热销id
        //   storeId: this.wareid
        // }
        let data = []
        let obj = {
          partId: this.partId, // 商品id
          tenantId: this.goodsdetails.tenantId, // 店铺的租户id
          partNum:
            this.goodsdetails.maxNum == null
              ? this.goodsdetails.orderQuantity
              : this.goodsdetails.maxNum, // 购买数量
          shopId: this.shopId, // 热销id
          storeId: this.wareid,
          isGive: 0
        }
        data.push(obj)
        if(this.goodsdetails.isGiveList&&this.goodsdetails.isGiveList.length && this.goodsdetails.maxNum >= this.goodsdetails.giveNum) {
          this.goodsdetails.isGiveList.forEach((item) => {
            let obj2 = {
              partId: item.partsId, // 商品id
              tenantId: this.goodsdetails.tenantId, // 店铺的租户id
              partNum: this.goodsdetails.giveNum1,// 赠送数量
              shopId: this.shopId, // 热销id
              storeId: this.wareid,
              isGive: 1
            }
            data.push(obj2)
          })
        }
        // } else {
        //   data = {
        //     partId: this.partId, // 商品id
        //     tenantId: this.goodsdetails.tenantId, // 店铺的租户id
        //     partNum:
        //       this.goodsdetails.maxNum == null
        //         ? this.goodsdetails.orderQuantity
        //         : this.goodsdetails.maxNum, // 购买数量
        //     shopId: this.shopId // 热销id
        //   }
        // }
        let res
        if(this.goodsdetails.activityType){
          res = await getpromptlybuy1(data)
        }else{
          res = await getpromptlybuy(obj)
        }
        //console.log(res)
        if (res.status) {
          this.$router.push({
            path: '/orderInformation',
            query: { pid: res.data.previewOrderId }
          })
        }
      } else {
        this.$Message.destroy()
        this.$Message.error('库存不足')
      }
    },
    // 立即询价
    promptlyxj(item) {
      // this.enquirytk = true
      this.$refs.enquirytkl.enquirytkc()
      this.enquirydata = JSON.parse(JSON.stringify(item))
    },
    // 询价刷新
    enquirysx() {
      this.$refs.store.getenquirydata()
    },
    // 顶部图片
    async getshopping() {
      const res = await getBasicShopMsg({
        tenantId: this.goodsdetails.tenantId,
        shopId: this.shopId
      })
      //console.log(res)
      if (res.status) {
        if (res.data) {
          this.logoTop = res.data.logoTop
        }
      }
    },
    // 车点击切换
    // 厂牌的切换
    async cehsi1(a, b) {
      this.carBrandName = a
      this.factoryName = ''
      this.carBrandSeriesName = ''
      this.carchecked1 = b
      this.carchecked2 = 0
      this.carchecked3 = 0
      this.getgoodsapplycar()
    },
    // 主机厂的切换
    async cehsi2(a, b) {
      this.factoryName = a
      this.carBrandSeriesName = ''
      this.carchecked2 = b
      this.carchecked3 = 0
      this.getgoodsapplycar()
    },
    // 车系的切换
    async cehsi3(a, b) {
      this.carBrandSeriesName = a
      this.carchecked3 = b
      this.getgoodsapplycar()
    },
    // 切换发货仓
    changeware(i) {
      console.log(i)
      this.wareName = i.city + i.name
      this.wareid = i.storeId
      this.goodsdetails.stock = i.stock
      this.goodsdetails.stockShow = i.stock
      this.goodsdetails.maxNum = 1
      this.goodsdetails.minNum = 1
      this.allprice = this.copyPrice
      // this.getStock()
    },
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.detail {
  display: inline-block;
  width: 30%;
}
.red {
  color: #d9001b;
}

.ellipsis {
  display: inline-block; /* 或者 block */
  overflow: hidden;
  word-wrap: break-word; /* 或者 word-break: break-all; */
  padding-right: 20px;
  width: 80%;
}
</style>
